
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';

import { Input } from '../../../components/ui/input';
import { toast } from 'sonner';
import { Button } from "../../../components/ui/button";

import { useConnection } from "@solana/wallet-adapter-react";
import { convertTime } from '../../utils/convertTime';

import { FaTelegram } from "react-icons/fa6";
import { FaDiscord } from "react-icons/fa6";
import { FaSquareXTwitter } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import PaymentSelector from './PaymentSelector';
import { useMakePayment } from '../../hooks/payments/useMakePayment';
import { useSolPrice } from '../../hooks/useSolPrice';
import { FaCheckCircle } from "react-icons/fa";




const SubscriptionPayment = () => {

  const { select, publicKey, connected, disconnect, sendTransaction } = useWallet();
  const [subscription, SetSubsctription] = useState(1)
  const [user, setUser] = useState(false)
  // const [transaction, setTransaction] = useState(false)
  const [loading, setLoading] = useState(true)


  const router = useNavigate()


  // const { pay, Vault, transaction } = useMakePayment(subscription)


  // const getData = async () => {
  //   publicKey?.toBase58() && toast.promise(
  //     axios.get('https://archangelbot.fun/api/subscribe', {
  //       headers: {
  //         walletAddress: publicKey.toBase58()
  //       }
  //     }).then((res) => res.data),
  //     {
  //       loading: 'Loading Please Wait ...',
  //       success: (data) => {
  //         setUser(data)
  //         setLoading(false)
  //         return `${data.isValid ? "you are whitelisted 🎉👏🥳" : "you are not whitelisted yet ! choose a plan !"} `;
  //       },
  //       error: 'error Please contact support'
  //     });
  // }


  // const showToast = (title, description, params) => {
  //   toast(title, {
  //     className: `  shadow text-neutral-200 border-orange-500/10 bg-black/50 `,
  //     description: description,
  //     duration: params?.duration || 5000,
  //     position: params?.position || 'top-left',
  //     dismissible: true,
  //   });
  // }

  // useEffect(() => {
  //   connected && getData()
  //   !connected && setUser(null)
  // }, [publicKey, transaction, connected])



  // const createSubscription = async (transactionDetails) => {
  //   try {
  //     const response = await axios.post('https://archangelbot.fun/api/subscribe', {
  //       walletAddress: transactionDetails.walletAddress,
  //       transactionSignature: transactionDetails.transactionSignature,
  //       duration: transactionDetails.duration // or 'monthly'
  //     }, {
  //       headers: {
  //         'Content-Type': 'application/json', // Ensure the server knows it's JSON
  //         'walletaddress': publicKey?.toBase58(), // Custom header if needed
  //       }
  //     });
  //     // Store download token securely
  //     localStorage.setItem('downloadToken', response.data.downloadToken);
  //     return response.data;
  //   } catch (error) {
  //     console.error('Subscription failed:', error);
  //     throw error;
  //   }
  // };



  // const PaySubscription = async () => {
  //   // const vault = await axios.get('https://archangelbot.fun/api/vault',{
  //   //   headers: {
  //   //     walletAddress: publicKey.toBase58()
  //   //   }
  //   // }).then((res)=>res.data)
  //   if (subscription >= 1 ) {
  //     try {
  //       const vaultKey = new PublicKey(recipient);

  //       const transaction = new Transaction();
  //       const sendSolInstruction = SystemProgram.transfer({
  //         fromPubkey: publicKey,
  //         toPubkey: vaultKey,
  //         lamports: Number(subscription) * LAMPORTS_PER_SOL,
  //       });

  //       transaction.add(sendSolInstruction);

  //       const signature = await sendTransaction(transaction, connection);
  //       const confirmed = await connection.confirmTransaction(signature, 'confirmed');


  //       // confirmed && signature && await createSubscription({
  //       //   walletAddress: publicKey?.toBase58(),
  //       //   transactionSignature: signature,
  //       //   duration: Number(subscription)
  //       // })
  //       setTransaction(signature)

  //     } catch (error) {
  //       console.error("Transaction failed", error);
  //     }

  //   }
  // }




  return (
    <div className="flex justify-center items-center   p-4 py-10 bg-gradient-to-tl from-black to-black/20 w-full rounded-2xl z-10">

      <div className="w-full max-w-md space-y-5">

      

      <div className='flex flex-cols font-light flex-col justify-center items-center gap-5'>
            {/* <p>your Subscription ends At : </p>
            <p className='text-2xl text-center text-neutral-400'>{convertTime(user.expiresAt)}</p>
            <Button
              onClick={startTrading}
              disabled={!connected}
              className="w-full hover:bg-yellow-500 bg-neutral-900 hover:text-black">
              Start Trading

            </Button> */}

            
                <p className='font-logo text-3xl text-center'> Thank you for your Support and intrest on Phoenix !  Subscriptions Are not Open Yet you can whitelist instead  </p>

                <Button onClick={()=>router('/whitelist')}  className="w-full bg-yellow-500 hover:bg-orange-500 text-black">Whitelist Now 👏 </Button>
                <p className='text-center'>Please join our telegram channel and group and follow us for latest updates </p>
          </div>

{/* 
        {user?.isValid && !loading &&
          <div className='flex flex-cols font-light flex-col justify-center items-center gap-5'>
            <p>your Subscription ends At : </p>
            <p className='text-2xl text-center text-neutral-400'>{convertTime(user.expiresAt)}</p>
            <Button
              onClick={startTrading}
              disabled={!connected}
              className="w-full hover:bg-yellow-500 bg-neutral-900 hover:text-black">
              Start Trading

            </Button>

            <div className=' grid grid-cols-1 gap-2 w-full'>
              <div className='bg-green-800/20 flex gap-2 px-5 py-4 rounded-full items-center w-full '>
                <FaCheckCircle className='text-green-500 text-2xl' />
                <p className=''> Thank you for your Support you are whitelisted for Bot Early Access and token Private Sale 🎉🎉🥳 </p>
              </div>
            </div>

                <p className='text-center'>Please join our telegram channel and group and follow us for latest updates </p>
          </div>} */}





        {/* {!user?.isValid && connected && !loading &&
          <div className='flex flex-col gap-5 w-full'>
            <PaymentSelector />
            <Button onClick={ ()=> pay() } disabled={!connected} className="w-full bg-yellow-500 hover:bg-orange-500 text-black">Whitelist Me 👏 </Button>
          </div>
        } */}


        <div className='flex gap-5 items-center text-center justify-center'>
          <FaTelegram className='text-2xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
          <FaSquareXTwitter className='text-2xl text-yellow-500 hover:text-orange-500 hover:scale-[120%] transition-all cursor-pointer' />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPayment;